import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/box/box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleGrid"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/grid/simple-grid.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/link/link.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/list/list.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["VStack"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/stack/v-stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["TableContainer"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/table/table-container.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Table"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/table/table.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Tbody"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/table/tbody.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Td"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/table/td.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Th"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/table/th.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Thead"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/table/thead.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Tr"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/table/tr.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Heading"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/typography/heading.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["createContext"] */ "/vercel/path0/node_modules/@chakra-ui/utils/dist/esm/context.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/application-services/icons/hosted-cms.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/application-services/icons/hosted-elastic.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/application-services/icons/hosted-grafana.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/application-services/icons/hosted-netbox.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/application-services/icons/hosted-open-text.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/application-services/icons/inuvika.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/application-services/icons/rancher.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/dedicated-server/dedicated-server.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/baremetal.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/block_storage1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/containerizedHosting.0e1aa36b.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/costEfficient.4c199bb4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/dedicated_server.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/disaster_recovery.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/gpu_hosting.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/kubernetes.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/virtual_device_infrastructure.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/iaas/wordpress-service.2952b864.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/network-services/icons/network-nms.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/network-services/icons/noc-soc-helpdesk.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/network-services/icons/sdn-sd-wan.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/network-services/icons/wired-wireless-network.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/pocCloud/icons/certification-labs.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/pocCloud/icons/emulate-simulate-real.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/pocCloud/icons/network-automation.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/pocCloud/icons/network-digital-twins.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/pocCloud/icons/performance-labs.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/pocCloud/icons/physical-labs.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/privateCloud/icons/managed-unmanaged-comanaged.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/privateCloud/icons/openstack-cloud.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/privateCloud/icons/vmware-cloud.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/privateCloud/icons/zadara-cloud.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/accordionList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/cardsList/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/certificates/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/contactForm/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/features/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/heroCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/intro/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ourCustomers/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pageTabs/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/technologyPartners/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/views/dedicatedServers/components/solutions/index.tsx");
